var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-lazy-hydrate',{attrs:{"when-visible":""}},[_c('a-banner',{staticClass:"sidebar__banner banner-card--black",attrs:{"wrapped-in-card":false,"banner-settings":_vm.$options.consts.BANNER_SETTINGS.SIDEBAR.START_TRADING}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }